__turbopack_context__.v({
  "fade-in": "Navigation-module__Bs_SLG__fade-in",
  "list": "Navigation-module__Bs_SLG__list",
  "nav": "Navigation-module__Bs_SLG__nav",
  "navOpen": "Navigation-module__Bs_SLG__navOpen",
  "new": "Navigation-module__Bs_SLG__new",
  "overlay": "Navigation-module__Bs_SLG__overlay",
  "pageItem": "Navigation-module__Bs_SLG__pageItem",
  "pageLink": "Navigation-module__Bs_SLG__pageLink",
  "pageList": "Navigation-module__Bs_SLG__pageList",
  "scrollbar": "Navigation-module__Bs_SLG__scrollbar",
  "scrollbarThumb": "Navigation-module__Bs_SLG__scrollbarThumb",
  "section": "Navigation-module__Bs_SLG__section",
  "sectionTitle": "Navigation-module__Bs_SLG__sectionTitle",
  "selected": "Navigation-module__Bs_SLG__selected",
  "side-nav": "Navigation-module__Bs_SLG__side-nav",
  "toggleButton": "Navigation-module__Bs_SLG__toggleButton",
  "viewport": "Navigation-module__Bs_SLG__viewport",
});
